import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { printExcessBaggage } from '../../../../../src/utils/printers/ExcessBaggageTicket';
import { flagPrintBaggageVoucher, getPrintExcessBaggage } from '../../../../actions';

const PrintExcessBaggageTicketButton = ({
  baggage,
  dispatchGetPrintExcessBaggage,
  dispatchFlagPrintBaggageVoucher,
  printOnMount
}) => {
  const handlePrint = async () => {
    const excess = await dispatchGetPrintExcessBaggage({
      excessBaggageId: baggage.get('excessBaggage').id,
    });

    if (excess) {
      dispatchFlagPrintBaggageVoucher(true)
      printExcessBaggage(excess)
      setTimeout(()=>{
        dispatchFlagPrintBaggageVoucher(false)
      }, 4000)
    };
  };

  if (baggage.get('excessBaggage')) {
    return (
      <Button color="light" className="border" onClick={handlePrint} disabled={printOnMount}>
        <i className={`fa ${printOnMount ? "fa-spinner" : "fa-print"}`}  /> Exceso de Equipaje
      </Button>
    );
  }

  return null;
};

PrintExcessBaggageTicketButton.propTypes = {
  baggage: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchGetPrintExcessBaggage: PropTypes.func.isRequired,
  dispatchFlagPrintBaggageVoucher: PropTypes.func.isRequired,
    printOnMount: PropTypes.func.isRequired,
};

const mapStateToProps = ({ BaggageUnit }) => ({
  baggage: BaggageUnit.Baggage.getIn(['current', 'content']),
  printOnMount: BaggageUnit.Baggage.getIn(['current', 'printOnMount']),
});

const mapDispatchToProps = {
  dispatchGetPrintExcessBaggage: getPrintExcessBaggage,
  dispatchFlagPrintBaggageVoucher: flagPrintBaggageVoucher,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrintExcessBaggageTicketButton);
